enum UNIT_SYSTEMS {
    SI = 'SI',
    USCS = 'USCS',
    IMPERIAL = 'IMPERIAL',
}

export default UNIT_SYSTEMS
